export const FORBIDDEN_FOR_MANAGED_CLASS_ERROR =
  "Sorry, this class is synced with your school system. Please contact the IT department at your school for information.";
